import { ApolloError, NetworkStatus } from '@apollo/client'
import {
   APIStatus,
   API_FAILED,
   API_FETCHING,
   API_INITIAL,
   API_SUCCESS,
   API_FETCHING_PAGINATION
} from '@flowwai-frontend/shared/api-common'

export const getAPIStatus = ({
   isLoading,
   isError,
   called = true
}: {
   isLoading: boolean
   isError: boolean
   called?: boolean
}): APIStatus => {
   if (!called) return API_INITIAL
   switch (true) {
      case isError:
         return API_FAILED
      case isLoading:
         return API_FETCHING
      default:
         return API_SUCCESS
   }
}

export const getAPIStatusFromNetworkStatus = (
   networkStatus: NetworkStatus,
   data
): APIStatus => {
   switch (networkStatus) {
      case NetworkStatus.setVariables:
         return API_INITIAL
      case NetworkStatus.loading:
         return API_FETCHING
      case NetworkStatus.fetchMore:
         return API_FETCHING_PAGINATION
      case NetworkStatus.error:
         return API_FAILED
      case NetworkStatus.refetch:
         return API_INITIAL
      case NetworkStatus.ready:
         return data ? API_SUCCESS : API_INITIAL
      default:
         return API_INITIAL
   }
}

export const convertToErrorType = (
   apolloError: ApolloError | undefined
): Error | null => {
   if (!apolloError) return null

   const errorMessage = apolloError?.message
   const error = new Error(errorMessage)

   return error
}
